import { supabase } from '@/lib/supabase';

/** sender_id είναι nullable στη βάση (ο συνομιλητής μπορεί να έχει διαγράψει
 * τον λογαριασμό του) — ίδιο πρότυπο με το agreementMessages.ts. */
export const DELETED_SENDER_ID = 'deleted-user';

export type ConnectionMessage = {
  id: string;
  connection_id: string;
  sender_id: string;
  body: string;
  created_at: string;
};

type DbConnectionMessage = Omit<ConnectionMessage, 'sender_id'> & { sender_id: string | null };

const SELECT_COLUMNS = 'id, connection_id, sender_id, body, created_at';

function normalize(row: DbConnectionMessage): ConnectionMessage {
  return { ...row, sender_id: row.sender_id ?? DELETED_SENDER_ID };
}

/** Το connection_id (accepted) ανάμεσα σε εμένα και το άλλο άτομο, ή null αν δεν υπάρχει. */
export async function getConnectionIdWith(otherUserId: string): Promise<string | null> {
  const { data, error } = await (supabase.rpc as any)('get_connection_id_with', { p_other_id: otherUserId });
  if (error) throw error;
  return (data as string | null) ?? null;
}

export async function fetchConnectionMessages(connectionId: string): Promise<ConnectionMessage[]> {
  const { data, error } = await (supabase as any)
    .from('connection_messages')
    .select(SELECT_COLUMNS)
    .eq('connection_id', connectionId)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return ((data ?? []) as DbConnectionMessage[]).map(normalize);
}

export async function markConnectionMessagesRead(connectionId: string): Promise<void> {
  const { error } = await (supabase.rpc as any)('mark_connection_messages_read', { p_connection_id: connectionId });
  if (error) throw error;
}

export async function fetchConnectionMessageReads(connectionId: string): Promise<Record<string, string>> {
  const { data, error } = await (supabase as any)
    .from('connection_message_reads')
    .select('user_id, last_read_at')
    .eq('connection_id', connectionId);
  if (error) throw error;
  const map: Record<string, string> = {};
  for (const row of (data ?? []) as { user_id: string; last_read_at: string }[]) map[row.user_id] = row.last_read_at;
  return map;
}

export async function sendConnectionMessage(connectionId: string, senderId: string, body: string): Promise<ConnectionMessage> {
  const trimmed = body.trim();
  const { data, error } = await (supabase as any)
    .from('connection_messages')
    .insert({ connection_id: connectionId, sender_id: senderId, body: trimmed })
    .select(SELECT_COLUMNS)
    .single();
  if (error) throw error;
  return normalize(data as DbConnectionMessage);
}
